import React from 'react';

const SkeletonLoader = () => {
  return (
    <div className="w-full max-w-4xl mx-auto space-y-6">
      {/* Banner Skeleton */}
      <div className="w-full h-32 rounded-3xl bg-gray-800/50 animate-pulse backdrop-blur-md border border-gray-700/50"></div>
      
      {/* Podium Skeleton */}
      <div className="flex justify-center items-end gap-4 h-48 mt-8 mb-12">
        <div className="w-24 h-32 bg-gray-800/50 rounded-t-xl animate-pulse"></div>
        <div className="w-24 h-40 bg-gray-800/50 rounded-t-xl animate-pulse"></div>
        <div className="w-24 h-28 bg-gray-800/50 rounded-t-xl animate-pulse"></div>
      </div>

      {/* Table Skeletons */}
      <div className="space-y-3">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="w-full h-16 rounded-2xl bg-gray-800/50 animate-pulse border border-gray-700/30"></div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonLoader;
